import { createContext, useContext } from "react"
import { LoginFunction,sendOTPHandler, resendOTPHandler,signupHandler} from "./RegistrationHelper"
const RegistrationContext = createContext()

export const RegistrationProvider = ({ children }) => {
    return <RegistrationContext.Provider value={{ LoginFunction, sendOTPHandler, resendOTPHandler, signupHandler }}>
        {children}
    </RegistrationContext.Provider>
}
export const useRegistration = () => useContext(RegistrationContext)
